export const campaignConstants = {
  GETALL_REQUEST: 'CAMPAIGNS_GETALL_REQUEST',
  GETALL_SUCCESS: 'CAMPAIGNS_GETALL_SUCCESS',
  GETALL_FAILURE: 'CAMPAIGNS_GETALL_FAILURE',

  GET_REQUEST: 'CAMPAIGNS_GET_REQUEST',
  GET_SUCCESS: 'CAMPAIGNS_GET_SUCCESS',
  GET_FAILURE: 'CAMPAIGNS_GET_FAILURE',

  ADD_REQUEST: 'CAMPAIGNS_ADD_REQUEST',
  ADD_SUCCESS: 'CAMPAIGNS_ADD_SUCCESS',
  ADD_FAILURE: 'CAMPAIGNS_ADD_FAILURE',

  UPDATE_REQUEST: 'CAMPAIGNS_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'CAMPAIGNS_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'CAMPAIGNS_UPDATE_FAILURE',
}